import React, { useEffect, useState, useContext, useRef } from 'react';
import { editImage, getImageById, getImageFileUrl } from '../../../services/mediaService';

const ThumbnailItemComponent = ({ item, size, imageItem, onClick }) => {
  const [isAvailable, setIsAvailable] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const fullUrl = getImageFileUrl(item.id);

  useEffect(() => {
    if (!fullUrl) return;

    setIsAvailable(null);
    setIsLoaded(false);

    const image = new Image();
    image.src = fullUrl;

    image.onload = () => {
      setIsAvailable(true);
      setIsLoaded(true);

    };

    image.onerror = () => {
      setIsAvailable(false);
      setIsLoaded(false);

    };
  }, [fullUrl]);

  return (
    isAvailable === null ? (
      <span>Töltés...</span>
    ) : isAvailable ? (
      <img
        src={fullUrl}
        alt="Thumbnail"
        className={`slideshow-thumbnail ${isLoaded ? (item.id === imageItem.id ? 'active' : '') : ''}`}
        style={{ width: size, height: size, cursor: 'pointer' }}
        onClick={onClick} // 👈 itt használod

      />
    ) : (
      <i className="bi bi-file-earmark-image" style={{ fontSize: size }} />
    )
  );
};

export default ThumbnailItemComponent;
